import { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  resize,
  connectWallet as connectWallet1,
  switchLoding,
  changeFees,
  changeRpc,
} from "./stores/actions/";
import "./App.less";
import ConnectButton from "./components/ConnectButton";
import SEOManager from "./components/Seo";
import Chain from "./components/Chain";
import RouteView from "./router/index";
import { Spin, message } from "antd";
import { useTranslation } from "react-i18next";
import { DEFAULT_RPC, THEME } from "./config";
import { getEvmFees } from "./utils/gas";
import { getLocCus, getLocRpc, setLocStorageRpc } from "./request/delay";
import { Button } from 'antd';
import { ChainSelector, DEFAULT_CHAIN_CONFIG, HOT_CHAIN_LIST } from '@fu2025831/react-kit';
function App() {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();



  const { connected } = useSelector((state: any) => {
    return state.wallet;
  });
  const { load, desc } = useSelector((state: any) => {
    return state.loadControll;
  });
  const [theme, setTheme] = useState("light");

  const toggleTheme = () => {
    const newTheme = THEME === "eth" ? "" : THEME;
    setTheme(newTheme);
    document.documentElement.setAttribute("data-theme", newTheme); // 设置数据属性
  };

  function size() {
    const w = document.body.clientWidth;
    const isM = w > 750 ? false : true;
    const is1920 = w >= 1920;
    const is1440 = w >= 1440 && w < 1920;
    const is1200 = w >= 1200 && w < 1440;
    const is750 = w > 750 && w < 1200;
    dispatch(
      resize({
        isM,
        is1920,
        is1440,
        is1200,
        is750,
      })
    );
  }

  async function defaultSetting() {
    const fees = await getEvmFees();
    dispatch(changeFees(fees));

    const locRpc = getLocRpc();
    setLocStorageRpc(locRpc);
    dispatch(changeRpc(locRpc));

    // if(!locRpc) {
    //   setLocStorageRpc(DEFAULT_RPC)
    //   dispatch(changeRpc(DEFAULT_RPC))
    // }else {
    //   dispatch(changeRpc(locRpc))
    // }
  }

  useEffect(() => {
    size();
    window.onresize = () => {
      size();
    };

    // if (refWebgl.current) {
    //   refWebApp.current = new ThreeApp(refWebgl.current)
    //   refWebApp.current.render()
    // }

    toggleTheme();
  }, []);

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  useEffect(() => {
    defaultSetting();
  }, []);

  return (
    <>
      <Chain />
      <SEOManager />
      <Spin spinning={load} tip={desc} delay={500} wrapperClassName="spin-box">
        <RouteView />
      </Spin>
    </>
  );
}

export default App;
